import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import { withFormik } from 'formik';

import moment from 'moment';
import * as Yup from 'yup';

import PropTypes from 'prop-types';

import {
  BulmaHero
} from '../../components/HelperComponents/HelperComponents';

import {
  InputBlack,
  AccountCreationH1,
  AccountCreationH2,
  PrimaryButton,
  SecondaryButton,
  FormWrapper
} from '../../components/HelperComponents/StyledComponents';

import BackgroundImage from '../../images/background.png';

import {registerUser} from '../../actions/UserActions';

// Our inner form component which receives our form's state and updater methods as props
const InnerForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
}) => (
  <FormWrapper onSubmit={handleSubmit} className="has-text-white">
    <AccountCreationH1 className="is-uppercase has-text-weight-bold">Account Creation</AccountCreationH1>
    <AccountCreationH2>Personal Info</AccountCreationH2>

    <div className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          type="text"
          name="username"
          placeholder="Username"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.username}
        />
        {touched.username && errors.username && <p className="help is-danger">{errors.username}</p>}
      </div>
    </div>

    <div className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          type="email"
          name="email"
          placeholder="Email"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
        />
        {touched.email && errors.email && <p className="help is-danger">{errors.email}</p>}
      </div>
    </div>

    <div className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          type="text"
          name="first_name"
          placeholder="First Name"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.first_name}
        />
        {touched.first_name && errors.first_name && <p className="help is-danger">{errors.first_name}</p>}
      </div>
    </div>

    <div className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          type="text"
          name="last_name"
          placeholder="Last Name"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.last_name}
        />
        {touched.last_name && errors.last_name && <p className="help is-danger">{errors.last_name}</p>}
      </div>
    </div>

    <div className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          type="date"
          name="birth_date"
          placeholder="Birth Date"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.birth_date}
        />
        {touched.birth_date && errors.birth_date && <p className="help is-danger">{errors.birth_date}</p>}
      </div>
    </div>

    <div className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          type="text"
          name="company"
          placeholder="Company"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.company}
        />
        {touched.company && errors.company && <p className="help is-danger">{errors.company}</p>}
      </div>
    </div>

    <div className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          type="text"
          name="position"
          placeholder="Position"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.position}
        />
        {touched.position && errors.position && <p className="help is-danger">{errors.position}</p>}
      </div>
    </div>

    <div className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          type="text"
          name="address"
          placeholder="Address"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.address}
        />
        {touched.address && errors.address && <p className="help is-danger">{errors.address}</p>}
      </div>
    </div>

    <div className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          type="text"
          name="postcode"
          placeholder="Postal Code"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.postcode}
        />
        {touched.postcode && errors.postcode && <p className="help is-danger">{errors.postcode}</p>}
      </div>
    </div>

    <div className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          type="text"
          name="country"
          placeholder="Country"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.country}
        />
        {touched.country && errors.country && <p className="help is-danger">{errors.country}</p>}
      </div>
    </div>

    <AccountCreationH2>Account Info</AccountCreationH2>

    <div className="field">
      <div className="control" >
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          placeholder="Password"
          type="password"
          name="password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
        />
        {touched.password && errors.password && <p className="help is-danger">{errors.password}</p>}
      </div>
    </div>

    <div className="field">
      <div className="control" >
        <InputBlack
          className="input is-transparent input-black is-rounded has-background-dark"
          placeholder="Confirm Password"
          type="password"
          name="confirmPasword"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.confirmPasword}
        />
        { touched.confirmPasword && errors.confirmPasword && <p className="help is-danger">{errors.confirmPasword}</p>}
      </div>
    </div>

    <div className="field">
      <div className="control">
        <label className="checkbox has-text-white">
            <input type="checkbox" name="terms" onChange={handleChange}
              onBlur={handleBlur}
              value={values.terms}/>
          <span> I agree to the Terms and Conditions</span>

          {touched.terms && errors.terms && <p className="help is-danger">{errors.terms}</p>}

        </label>
      </div>
    </div>

    <section className="field is-grouped is-grouped-right">

      <div className="control">
        <SecondaryButton className="button is-dark is-rounded" type="button">
          <Link to="/" className="has-text-white">
            Cancel
          </Link>
        </SecondaryButton>
      </div>
     <div className="control">
        <PrimaryButton className="button is-rounded" type="submit" disabled={isSubmitting}>
          Create Acccount
        </PrimaryButton>
     </div>

    </section>
  </FormWrapper>
);

InnerForm.propTypes = {
  values: PropTypes.any,
  errors: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
  touched: PropTypes.any,
  isSubmitting: PropTypes.any
};

export class SignUpComponent extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object
  }

  render() {
    let minDate = moment().subtract(100, 'years');
    let maxDate = moment().subtract(18, 'years');


    // Wrap our form with the using withFormik HoC
    const MyForm = withFormik({
      validationSchema: Yup.object({
        username: Yup.string().required('Username is required'),
        email: Yup.string().email().required('Email is required'),
        first_name: Yup.string().required('First name is required'),
        last_name: Yup.string().required('Last name is required'),
        birth_date: Yup.date()
          .min(minDate, `Min date should be ${minDate.format('MM/DD/YYYY').toString()}`)
          .max(maxDate, `Max date should be  ${maxDate.format('MM/DD/YYYY').toString()}`),
        company: Yup.string().required('Company is required'),
        position: Yup.string().required('Position is required'),
        address: Yup.string().required('Address is required'),
        country: Yup.string().required('Country is required'),
        postcode: Yup.string().required('Post Code is required'),

        password: Yup.string().required('Password is required'),
        confirmPasword: Yup.string()
          .oneOf([Yup.ref('password'), null], 'Passwords do not match')
          .required('Password confirm is required'),
        terms: Yup.boolean().oneOf([true], 'Must Accept Terms and Conditions')
      }),
      // Transform outer props into form values
      mapPropsToValues: _props => ({
        username: '',
        email: '',
        first_name: '',
        last_name: '',
        birth_date: '',

        company: '',
        position: '',
        address: '',
        country: '',
        postcode: '',

        password: '',
        confirmPasword: '',
        terms: false
      }),
      // Submission handler
      handleSubmit: (
        values,
        {
          _props,
          _setSubmitting,
          _setErrors /* setValues, setStatus, and other goodies */,
        }
      ) => {
        this.props.dispatch(registerUser(values, this.props.history));
      },
    })(InnerForm);

    const FormStructure = () => (
      <section className="container">
        <section className="columns is-centered">
          <section className="column is-4">
            <MyForm />
          </section>
        </section>
      </section>
    );

    return (
      <Fragment>
        <BulmaHero heroSize="is-fullheight" activateBodyPadding={true} body={<FormStructure />} image={BackgroundImage}></BulmaHero>
      </Fragment>
    );
  }
}

export const SignUp = connect()(SignUpComponent);



// WEBPACK FOOTER //
// ./src/routes/SignUp/SignUp.js